import { render, staticRenderFns } from "./MemoCategory.vue?vue&type=template&id=188ba1ff&scoped=true"
import script from "./MemoCategory.vue?vue&type=script&lang=js"
export * from "./MemoCategory.vue?vue&type=script&lang=js"
import style0 from "./MemoCategory.vue?vue&type=style&index=0&id=188ba1ff&prod&lang=stylus&scoped=true"
import style1 from "./MemoCategory.vue?vue&type=style&index=1&id=188ba1ff&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ba1ff",
  null
  
)

export default component.exports